<template>
  <div class="cut-wrapper">

    <!-- 裁剪 -->
    <div class="cut-box">
      <vueCropper class="cropper"
                  ref="vueCropper"
                  :img="imgFile"
                  :fixed="cutOptions.fixed"
                  :canMove="cutOptions.canMove"
                  :autoCrop="cutOptions.autoCrop"
                  :centerBox="cutOptions.centerBox"
                  :fixedNumber="cutType === 'local'?cutOptions.fixedNumberLocal : cutOptions.fixedNumberPhone" />
    </div>

    <!-- 按钮 -->
    <div class="cut-btn-box">
      <div class="cut-btn" @click="goBackFunc()">上一步</div>
      <div class="cut-btn" @click="debounce(() => { upImgFunc() }, 300)">{{ cutType === 'local' ? '完成' : '去编辑' }}</div>
    </div>

  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { componentsMixin } from '@/assets/js/mixins/components'

export default {
  props: {
    cutType: { // 裁剪模块类型 可能的值：1. local 本地上传 2. phone 手机上传
      type: String,
      default: null
    },
    imgFile: { // 要裁剪的图片文件 base64
      type: String,
      default: null
    }
  },
  data () {
    return {
      cutOptions: { // 裁剪插件 配置参数
        canMove: true,
        autoCrop: true,
        centerBox: true,
        fixed: true,
        fixedNumberLocal: [80, 96], // 本地上传 裁剪比例 用原比例
        fixedNumberPhone: [90, 126] // 手机上传 裁剪比例 用一寸
      }
    }
  },
  mixins: [ componentsMixin ],
  components: {
    VueCropper // 裁剪插件
  },
  methods: {
    // 上传图片
    upImgFunc () {
      this.$refs.vueCropper.getCropData(file => {
        // file：base64 图片
        if (this.cutType === 'local') {
          this.$emit('upLocalImgFunc', file)
        } else if (this.cutType === 'phone') {
          this.$emit('upPhoneImgFunc', file)
        }
      })
    },
    // 返回上一步
    goBackFunc () {
      if (this.cutType === 'local') {
        this.$emit('goBackLocalFunc')
      } else if (this.cutType === 'phone') {
        this.$emit('goBackPhoneFunc')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./index.scss";
</style>
